import jsCookie from "js-cookie";
import {DOMAIN} from "../config.tsx";

const cookie = {
    get: (key: string) => jsCookie.get(key),
    set: (key: string, value: any, config: any) =>
        jsCookie.set(key, value, config),
    remove: (key: string, config: any) => jsCookie.remove(key, config),
};

export const setCookie = (key: string, value: any) => {
    cookie.set(key, value, {
        expires: 365,
        path: '/',
        domain: DOMAIN,
    });
};
